<div class="dashboard">
  <div class="stats">
    @if (access()?.contract?.actions?.read) { @defer (when
    contractLengthModel()) {
    <div class="card-0">
      <app-stats [stats]="contractLengthModel()"></app-stats>
    </div>
    } @placeholder {
    <p-skeleton height="100rem"></p-skeleton>
    } } @if (access()?.image?.actions?.read) { @defer (when imageLengthModel())
    {
    <div class="card-0">
      <app-stats [stats]="imageLengthModel()"></app-stats>
    </div>
    } } @if (access()?.permission?.actions?.read) {
    <div class="card-0">
      <app-stats [stats]="permissionLengthModel()"></app-stats>
    </div>
    } @if (access()?.advertising?.actions?.read) {
    <div class="card-0">
      <app-stats [stats]="advertisingLengthModel()"></app-stats>
    </div>
    } @if (access()?.branch?.actions?.read) {
    <div class="card-0">
      <app-stats [stats]="branchLengthModel()"></app-stats>
    </div>
    } @if (access()?.user?.actions?.read) {
    <div class="card-0">
      <app-stats [stats]="userLengthModel()"></app-stats>
    </div>
    }
  </div>
  @if (access()?.turn?.actions?.read) {
  <div class="card-1">
    @defer (when rangeDates() && !!filtersGraft) {
    <app-turn-statistucs-grafhic
      [rangeDates]="rangeDates() ?? []"
      [branch]="filtersGraft?.branch"
      [contract]="filtersGraft?.contract"
      [servicio]="filtersGraft?.servicio"
      [detailed]="false"
    >
    </app-turn-statistucs-grafhic>
    }
  </div>
  <div class="card-1">
    @defer (when branchLengthModel() && servicioLengthModel()) {
    <app-turn-statistucs-list
      [detailed]="false"
      (rangeDatesOutput)="onRangeDates($event)"
      (filterOuput)="onFilter($event)"
    >
    </app-turn-statistucs-list>
    }
  </div>

  } @if (access()?.contract?.actions?.read) {
  <div class="card-1">
    <app-contract-list
      [detailed]="false"
      (length)="contractLength($event)"
    ></app-contract-list>
  </div>
  } @if (access()?.image?.actions?.read) {
  <div class="card-1">
    <app-images-list
      [detailed]="false"
      (length)="imageLength($event)"
    ></app-images-list>
  </div>
  } @if (access()?.permission?.actions?.read) {
  <div class="card-1">
    <app-permissions-list
      [detailed]="false"
      (length)="permissionLength($event)"
    ></app-permissions-list>
  </div>
  } @if (access()?.advertising?.actions?.read) {
  <div class="card-1">
    <app-advertising-list
      [detailed]="false"
      (length)="advertisingLength($event)"
    ></app-advertising-list>
  </div>
  } @if (access()?.role?.actions?.read) {
  <div class="card-1">
    <app-roles-list [detailed]="false"></app-roles-list>
  </div>
  } @if (access()?.servicio?.actions?.read) {
  <div class="card-1">
    <app-servicios-list
      [detailed]="false"
      (length)="serviciosLength($event)"
    ></app-servicios-list>
  </div>
  } @if (access()?.branch?.actions?.read) {
  <div class="card-1">
    <app-branches-list
      [detailed]="false"
      (length)="branchLength($event)"
    ></app-branches-list>
  </div>
  } @if (access()?.user?.actions?.read) {
  <div class="card-1">
    <app-user-list
      [detailed]="false"
      (length)="userLength($event)"
    ></app-user-list>
  </div>
  }
</div>
